import { callbacks, setCallback } from './callbacks';
import { app } from './appEnvironment';
import utils from '../scripts/utils';
import log from './logger';
import miniapp from '../model/miniapp';
import operation from '../constants/operationType';
import api from '../service/api';

const startPaymentsFlow = (data, successCallback, errorCallback, canceledCallback) => {
    setCallback("afterPaymentsSuccess", successCallback);
    setCallback("afterPaymentsError", errorCallback);
    setCallback("afterPaymentsCanceled", canceledCallback);

    if (data === undefined || data.value === undefined) {
        callbacks.afterPaymentsError({ message: "Valor é obrigatório para efetuar o pagamento." });
        return;
    }

    const analyticsData = log.formatAnalyticsData(
        miniapp.platform,
        miniapp.miniappName,
        miniapp.miniappId,
        miniapp.username,
        operation.PAYMENT_STARTED,
        data.value
    );

    log.logAction(analyticsData, () => {
        app.callFunction("startPaymentsFlow", data);
    });
}

const startRefundFlow = (data, successCallback, errorCallback) => {
    setCallback("afterRefundSuccess", successCallback);
    setCallback("afterRefundError", errorCallback);

    if (data === undefined || data.id === undefined) {
        callbacks.afterRefundError({ message: "Código do pagamento é obrigatório para efetuar o reembolso." });
        return;
    }

    app.callFunction("startRefundFlow", data);
}

const askPaymentStatus = (data, successCallback, errorCallback) => {
    setCallback("afterPaymentStatusSuccess", successCallback);
    setCallback("afterPaymentStatusError", errorCallback);

    api.get('wallets/qrcode/' + data.id + '/status').then((data) => {
        callbacks.afterPaymentStatusSuccess(data.data);
    }).catch((error) => {
        callbacks.afterPaymentStatusError(error.response);
    });
}

const onPaymentsFlowSuccess = (data) => {
    data = utils.fromStringToJson(data);

    const analyticsData = log.formatAnalyticsData(
        miniapp.platform,
        miniapp.miniappName,
        miniapp.miniappId,
        miniapp.username,
        operation.PAYMENT_SUCCESS
    );

    log.logAction(analyticsData, () => {
        callbacks.afterPaymentsSuccess(data);
    });
}

const onPaymentsFlowError = (data) => {
    data = utils.fromStringToJson(data);

    const analyticsData = log.formatAnalyticsData(
        miniapp.platform,
        miniapp.miniappName,
        miniapp.miniappId,
        miniapp.username,
        operation.PAYMENT_ERROR
    );

    log.logAction(analyticsData, () => {
        callbacks.afterPaymentsError(data);
    });
}

const onPaymentsFlowCanceled = (data) => {
    data = utils.fromStringToJson(data);
    const analyticsData = log.formatAnalyticsData(
        miniapp.platform,
        miniapp.miniappName,
        miniapp.miniappId,
        miniapp.username,
        operation.PAYMENT_CANCELED
    );

    log.logAction(analyticsData, () => {
        callbacks.afterPaymentsCanceled(data);
    });
}

const onRefundFlowSuccess = () => {
    callbacks.afterRefundSuccess();
}

const onRefundFlowError = (data) => {
    data = utils.fromStringToJson(data);
    callbacks.afterRefundError(data);
}

const initPayment = () => {
    window.onPaymentsFlowSuccess = onPaymentsFlowSuccess;
    window.onPaymentsFlowError = onPaymentsFlowError;
    window.onPaymentsFlowCanceled = onPaymentsFlowCanceled;
    window.onRefundFlowSuccess = onRefundFlowSuccess;
    window.onRefundFlowError = onRefundFlowError;
}

export { startPaymentsFlow, startRefundFlow, askPaymentStatus, initPayment };